import BaseObject from '../../../../base/base_object';
import Device from '../../../../utils/device/device';
import _ from "../../../../utils/underscore";
import {KEY_NAME} from "../../native/native_const";


class Scheme extends BaseObject {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'Scheme';

    _HybridService = null;
    _bSchemeSupported = false;
    _strGamescheme = '';
    _bEnable = false;


    init(params) {

        if (Device.hybrid.isEmbedded) {
            params = params.ios;
            if (!_.isNullOrUndefined(params) && !_.isNullOrUndefined(params.enable)) {
                this._bEnable = params.enable;
            }
        }

        super.init(params);
    }

    initFeatures(hybridSrv) {
        this._HybridService = hybridSrv;

        if (this._bEnable) {
            this.checkSchemeSupported();
        }

        return this;
    }



    checkSchemeSupported(){

        this._HybridService.checkSchemeSupported().then(data => {
            data = _.safeJSONandDecode(data);

            let error = data[KEY_NAME.ERROR];
            if (error !== 0) {
                return;
            }

            let keyData = data[KEY_NAME.DATA];
            if(undefined !== keyData) {
                const httpsSupported = (keyData[KEY_NAME.SCHEME_SUPPORTED] === 'true');
                this.setSchemeSupported(httpsSupported);
            }
        })
    }

    setSchemeSupported(val){
        this._bSchemeSupported = val;
    }

    isSchemeSupported(){
        return this._bSchemeSupported;
    }

    setGamescheme(gameschcme){
        this._strGamescheme = gameschcme;
    }

    getGamescheme(){
        return this._strGamescheme;
    }

}
export default Scheme;
